[
    { "name": "aa_togglePhysicianPaymentType (Dev Only)", "sdkVisible": false, "example": "" },
    { "name": "aa_LoadPhyNpiTaxonomy (Dev Only)", "sdkVisible": false, "example": "" },
    {
        "name": "aa_SetEgpSortRules (Dev Only)",
        "sdkVisible": false,
        "example": {
            "includePriority": "",
            "includeSeverity": "",
            "includeMortality": "",
            "includeElixhauser": "",
            "includeHcc": "",
            "includeRa": "",
            "includePxPriority":  ""
        }
    },
    { "name": "aa_CreateAgpInput (Dev Only)", "sdkVisible": false, "example": "" },
    {
        "name": "acsuCloneDischargeDisposition (Dev Only)",
        "sdkVisible": false,
        "example": {
            "xml": "xmlgoeshere"
        }
    },
    {
        "name": "acsuGetFacilitiesByIds (Dev Only)",
        "sdkVisible": false,
        "example": {
            "xml": "xmlgoeshere"
        }
    },
    {
        "name": "acsuGetFacilitiesByUsernames (Dev Only)",
        "sdkVisible": false,
        "example": {
            "xml": "xmlgoeshere"
        }
    },
    {
        "name": "acsuMergeMultiRegion (Dev Only)",
        "sdkVisible": false,
        "example": {
            "xml": "xmlgoeshere"
        }
    },
    {
        "name": "acsuSaveDischargeDisposition (Dev Only)",
        "sdkVisible": false,
        "example": {
            "xml": "xmlgoeshere"
        }
    },
    {
        "name": "acsuSaveWebstratUser (Dev Only)",
        "sdkVisible": false,
        "example": {
            "xml": "xmlgoeshere"
        }
    },
    {
        "name": "addGhostRows (Dev Only)",
        "sdkVisible": false,
        "example": {
            "includeAdmitTypeAndAdmissionSource": false
        }
    },
    {
        "name": "addRemCodes (Dev Only)",
        "sdkVisible": false,
        "example": {
            "diagnosisCodes": [
                {
                    "code": "B700",
                    "codeType": "REMD",
                    "label": "short label",
                    "longLabel": "Long label"
                }
            ],
            "hcpcsCodes": [
                {
                    "code": "12001",
                    "codeType": "REMH",
                    "label": "short label",
                    "longLabel": "Long label",
                    "units": "1",
                    "modifier1": "26",
                    "modifier2": null,
                    "modifier3": null,
                    "modifier4": null,
                    "modifier5": null
                }
            ]
        }
    },
    { "name": "swapActiveAndGhostRows (Dev Only)", "sdkVisible": false, "example": "" },
    { "name": "recordMode (Dev Only)", "sdkVisible": false, "example": "" },
    {
        "name": "addCodes",
        "sdkVisible": true,
        "example": {
            "codes": [
                {
                    "code": "B700",
                    "codeType": "I10CM",
                    "dxIndic1": "N"
                },
                {
                    "code": "X2C1361",
                    "codeType": "ICD10PCS",
                    "date": "2024-03-21T20:01:28.953Z"
                }
            ],
            "editedcode": null,
            "codeSource": "encoder",
            "documentHighlight": true
        }
    },
    {
        "name": "deleteCodes",
        "sdkVisible": true,
        "example": {
            "codes": [
                {
                    "uniqueId": "uniqueIdgoeshere",
                    "codeType": "I10CM"
                }
            ]
        }
    },
    { "name": "defaultSettings", "sdkVisible": false, "example": "" },
    { "name": "getInputPatientClaim", "sdkVisible": false, "example": "" },
    {
        "name": "getPayerList",
        "sdkVisible": true,
        "example": {
            "sendingFacility": "001",
            "npi": null,
            "payer": null,
            "taxonomy": null,
            "paymentType": "01"
        }
    },
    { "name": "getPatientRecord", "sdkVisible": false, "example": "" },
    { "name": "getPatientRecord-truncated", "sdkVisible": false, "example": "" },
    { "name": "getOptimizerInput", "sdkVisible": false, "example": "" },
    {
        "name": "cacAuthenticateUser (Dev Only)",
        "sdkVisible": false,
        "example": {
            "user": "UserName",
            "pw": "EncryptedPW",
            "isForLogin": true
        }
    },
    {
        "name": "cacChangePwd (Dev Only)",
        "sdkVisible": false,
        "example": {
            "user": "UserName",
            "currentPw": "EncryptedPw",
            "newPw": "EncryptedPw"
        }
    },
    { "name": "cacGetGroups (Dev Only)", "sdkVisible": false, "example": "" },
    {
        "name": "cacResetPwd (Dev Only)",
        "sdkVisible": false,
        "example": {
            "user": "UserName",
            "newPw": "EncryptedPw"
        }
    },
    { "name": "cacGetUserInfo (Dev Only)", "sdkVisible": false, "example": { "user": "UserName" } },
    {
        "name": "cacUpdateLastLoginTime (Dev Only)",
        "sdkVisible": false,
        "example": {
            "user": 12345
        }
    },
    { "name": "callClaimsManager (Dev Only)", "sdkVisible": false, "example": "" },
    { "name": "closeAllKCWindows", "sdkVisible": false, "example": "" },
    { "name": "closeAllKCWindowsExceptEncoder", "sdkVisible": true, "example": "" },
    { "name": "clearSelectedRow", "sdkVisible": true, "example": "" },
    { "name": "clearPatientRecord", "sdkVisible": true, "example": "" },
    { "name": "clearHighlight", "sdkVisible": false, "example": "" },
    { "name": "editsCount", "sdkVisible": false, "example": "" },
    { "name": "enableEncoder", "sdkVisible": false, "example": "" },
    { "name": "disableEncoder", "sdkVisible": false, "example": "" },
    { "name": "disableChildWindows", "sdkVisible": false, "example": "" },
    { "name": "enableChildWindows", "sdkVisible": false, "example": "" },
    { "name": "launchCodeSummaryReport", "sdkVisible": true, "example": "" },
    { "name": "launchEdits", "sdkVisible": true, "example": "" },
    {
        "name": "launchIndex",
        "sdkVisible": true,
        "example": {
            "codeType": "I10CM",
            "phrase": "ANGINA"
        }
    },
    {
        "name": "launchLogic",
        "sdkVisible": true,
        "example": {
            "codeType": "I10CM",
            "phrase": "ANGINA"
        }
    },
    {
        "name": "launchTabular",
        "sdkVisible": true,
        "example": {
            "codeType": "I10CM",
            "code": "A000"
        }
    },
    {
        "name": "launchFacilityLookup",
        "sdkVisible": true,
        "example": {
            "paymentType": "01",
            "rateFilePath": "C:\\inetpub\\wwwroot\\HSS\\Data\\allpaykc"
        }
    },
    {
        "name": "loadNotes",
        "sdkVisible": false,
        "example": {
            "AccessType": "All",
            "codeType": "I10CM",
            "NoteType": "Code",
            "Identifier": "",
            "IdentifierSearchLower": "",
            "IdentifierSearchUpper": "",
            "Category": "",
            "Ids": {
                "User": "",
                "Facility": "",
                "Organization": ""
            },
            "AllFacilities": true
        }
    },
    { "name": "loadOrganizationSettings", "sdkVisible": false, "example": "" },
    { "name": "loadPatientRecord", "sdkVisible": true, "example": "" },
    { "name": "openEncoder", "sdkVisible": true, "example": "" },
    { "name": "potentialImpactDisplay (Dev Only)", "sdkVisible": false, "example": "" },
    { "name": "potentialImpactClear", "sdkVisible": false, "example": "" },
    { "name": "potentialImpactDisable", "sdkVisible": false, "example": "" },
    { "name": "potentialImpactEnable", "sdkVisible": false, "example": "" },
    {
        "name": "potentialImpactEnableEgp",
        "sdkVisible": false,
        "example": {
            "enabled": false
        }
    },
    { "name": "potentialImpactInitialize", "sdkVisible": false, "example": "" },
    { "name": "resetApplication", "sdkVisible": true, "example": "" },
    { "name": "savePatientRecord", "sdkVisible": true, "example": "" },
    {
        "name": "selectRowOnHighlightClick",
        "sdkVisible": false,
        "example": {
            "uniqueId": "uniqueIdGoesHere"
        }
    },
    { "name": "setAuthToken", "sdkVisible": false, "example": "" },
    {
        "name": "toggleEgpCompression",
        "sdkVisible": false,
        "example": {
            "enableCompression": false
        }
    },
    {
        "name": "setChargeCapture",
        "sdkVisible": true,
        "example": [
            {
                "cptCode": "G0382",
                "modifiers": "77,GA,PO",
                "revCode": "450",
                "startDate": "2025-2-11",
                "units": 1,
                "codeRange": "99281-99285,99291-99292,G0380-G0384"
            },
            {
                "cptCode": "96365",
                "modifiers": "59,XE,XS,XU",
                "revCode": "450",
                "startDate": "Tue Feb 11 2025 13:25:46 GMT-0500 (Eastern Standard Time)",
                "units": 56,
                "codeRange": "96360-96361,96365-96368,96372,96374-96376"
            },
            {
                "cptCode": "99221",
                "modifiers": "IN,IP,IR,IS,IX",
                "revCode": "760",
                "startDate": "2025-02-11T00:00:00.000Z",
                "units": 9999,
                "codeRange": "99221-99223,99231-99233,99234-99236, 99238-99239,G0378 – G0379"
            }
        ]
    },
    { "name": "showCurrentConfig (Dev Only)", "sdkVisible": false, "example": "" },
    {
        "name": "updateAbstractInfo",
        "sdkVisible": false,
        "example": [
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "HCPCS",
                "abstractInfo": "A"
            }
        ]
    },
    { "name": "updateBaseUrl", "sdkVisible": false, "example": "" },
    {
        "name": "updateCodes",
        "sdkVisible": true,
        "example": [
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "I10CM",
                "dxIndic1": "Y"
            },
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "ICD10PCS",
                "date": "2024-03-21T20:01:28.953Z",
                "selectedProvider": "freeFormProvider"
            },
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "HCPCS",
                "date": "2024-03-21T20:01:28.953Z",
                "selectedProvider": "freeFormProvider",
                "revCode": "0250",
                "units": "1",
                "modifier1": {
                    "value": "23"
                },
                "i10Reimbursement": {
                    "charges": "$1,000.00"
                },
                "i9Reimbursement": {
                    "charges": "$1,000.00"
                }
            }
        ]
    },
    {
        "name": "updateComments",
        "sdkVisible": false,
        "example": [
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "I10CM",
                "comments": "C"
            }
        ]
    },
    { "name": "updateDemographics", "sdkVisible": true, "example": "" },
    {
        "name": "updateDocumentCount",
        "sdkVisible": false,
        "example": [
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "I10CM",
                "documentCount": "3"
            }
        ]
    },
    {
        "name": "updateExcludeFromBilling",
        "sdkVisible": false,
        "example": [
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "HCPCS",
                "excludeFromBilling": "X"
            }
        ]
    },
    {
        "name": "updateRedFlag",
        "sdkVisible": false,
        "example": [
            {
                "uniqueId": "uniqueIdGoesHere",
                "codeType": "I10CM",
                "redFlag": "F"
            }
        ]
    },
    { "name": "hasCriticalEdits", "sdkVisible": true, "example": "" },
    { "name": "hasEdits", "sdkVisible": true, "example": "" },
    { "name": "ReloadMainPod", "sdkVisible": false, "example": "" },
    { "name": "ReloadCodeSummary", "sdkVisible": false, "example": "" },
    { "name": "ReloadDemographics", "sdkVisible": false, "example": "" },
    { "name": "ReloadEdits", "sdkVisible": false, "example": "" },
    { "name": "ReloadReimbursement", "sdkVisible": false, "example": "" },
    { "name": "logout", "sdkVisible": true, "example": "" },
    { "name": "getRowSpecificInfo", "sdkVisible": true, "example": ["uniqueId1GoesHere", "uniqueId2GoesHere"] },
    { "name": "isEditGroupPriceInProgress", "sdkVisible": false, "example": "" },
    {
        "name": "addCodesNoEdit",
        "sdkVisible": false,
        "example": {
            "codes": [
                {
                    "code": "B700",
                    "codeType": "I10CM",
                    "dxIndic1": "N"
                },
                {
                    "code": "X2C1361",
                    "codeType": "ICD10PCS",
                    "date": "2024-03-21T20:01:28.953Z"
                }
            ]
        }
    },
    {
        "name": "setQueryImpactVisibility",
        "sdkVisible": false,
        "example": {
            "isVisible": true
        }
    },
    {
        "name": "setSyncVisibility",
        "sdkVisible": false,
        "example": {
            "isVisible": true
        }
    },
    {
        "name": "showScratchCodeState",
        "sdkVisible": false,
        "example": {
            "isVisible": true
        }
    },
    {
        "name": "showQueryHistoryState",
        "sdkVisible": false,
        "example": {
            "isVisible": true
        }
    },
    {
        "name": "showQueryHistoryBtn",
        "sdkVisible": false,
        "example": {
            "isVisible": true
        }
    },
    {
        "name": "updateCptWithRange",
        "sdkVisible": false,
        "example": {
            "codes": [
                {
                    "code": "",
                    "units": ""
                }
            ],
            "emCodeRanges": [
                {
                    "from": "",
                    "to": ""
                }
            ]
        }
    },
    {
        "name": "launchModal (Dev Only)",
        "sdkVisible": false,
        "example": {
            "messageType": "info",
            "title": "Test Modal",
            "message": ["Test Modal"]
        }
    },
    {
        "name": "simulateKcVersion (Dev Only)",
        "sdkVisible": false,
        "example": {
            "kcVersion": "1.2.3"
        }
    },
    {
        "name": "startEnvironmentPromiseRace (Dev Only)",
        "sdkVisible": false,
        "example": {
            "alternateUrl": "https://dev.kc-np.o360.cloud/v202501"
        }
    }
]
